import React from "react";
import Modal from "react-bootstrap/Modal";

import LinkComponent from "../Link";
import CloseIcon from "../../Icons/Close";

const Content = ({ children, header, onHide }) => (
  <Modal.Body className="p-0">
    {header && (
      <div className="d-flex align-items-center justify-content-between px-10 py-6 border-bottom border-gray-20">
        <p className="lead fw-bold">{header}</p>
        <LinkComponent onClick={onHide}>
          <CloseIcon />
        </LinkComponent>
      </div>
    )}
    {children}
  </Modal.Body>
);

export default Content;
